import { SHOP_ORDER_STATUSES } from "@seagames/contracts";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { MerchOrdersView } from "../../components/merch/orders-view";
import { keysetSearch, searchText } from "../../lib/list-page/list-search";

/**
 * Merchandising › Orders. URL = the list's state in the API's own keys, every
 * param lenient (`keysetSearch`): `q status needs_refund` + the keyset
 * `cursor` / `prev` / `limit`.
 */
export const Route = createFileRoute("/_app/merchandising/orders/")({
	validateSearch: keysetSearch({
		q: searchText(),
		status: z.enum(SHOP_ORDER_STATUSES),
		needs_refund: z.boolean(),
	}),
	component: OrdersPage,
});

function OrdersPage() {
	return <MerchOrdersView search={Route.useSearch()} navigate={Route.useNavigate()} />;
}
